import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PricingService {
  private readonly garmentsInfoUrl =
    'https://internalws.dryo.io/dryows/garments/garmentsInfo/?vendorId=1&storeId=1&priceListId=0';

  constructor(private http: HttpClient) {}

  getGarmentsInfo(): Observable<any> {
    return this.http.get<any>(this.garmentsInfoUrl);
  }
}
